<div class="register-container">
    <h2>Register</h2>
    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="register-form">
        <div class="row">
            <div [ngClass]="registerForm.get('userType')?.value ? 'col-6  col-sm-12' : 'col-12'">
                <mat-form-field appearance="outline">
                    <mat-label>User Type</mat-label>
                    <mat-select formControlName="userType">
                        <mat-option value="doctor">Physician</mat-option>
                        <mat-option value="support">Admin Staff</mat-option>
                    </mat-select>
                    <mat-error *ngIf="registerForm.get('userType')?.invalid">Please select a user type</mat-error>
                </mat-form-field>
            </div>
            <div class="col-6  col-sm-12" *ngIf="registerForm.get('userType')?.value">
                <mat-form-field appearance="outline">
                    <mat-label>Title</mat-label>
                    <mat-select formControlName="title">
                        <mat-option *ngFor="let title of titles" [value]="title.value">
                            {{ title.text }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="registerForm.get('title')?.touched && registerForm.get('title')?.invalid">Please
                        enter a
                        title</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row" *ngIf="registerForm.get('userType')?.value">
            <div class="col-6 col-sm-12">
                <mat-form-field appearance="outline">
                    <mat-label>Name</mat-label>
                    <input matInput type="text" formControlName="name" required>
                    <mat-error *ngIf="registerForm.get('name')?.invalid">Please enter a name</mat-error>
                </mat-form-field>
            </div>
            <div class="col-6 col-sm-12">
                <mat-form-field appearance="outline">
                    <mat-label>Surname</mat-label>
                    <input matInput type="text" formControlName="surname" required>
                    <mat-error *ngIf="registerForm.get('surname')?.invalid">Please enter a surname</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row" *ngIf="registerForm.get('userType')?.value">
            <div [ngClass]="registerForm.get('userType')?.value === 'doctor' ? 'col-6  col-sm-12' : 'col-12'">
                <mat-form-field appearance="outline">
                    <mat-label>Country</mat-label>
                    <mat-select formControlName="country">
                        <mat-option *ngFor="let country of countries" [value]="country.value">
                            {{ country.text }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="registerForm.get('country')?.touched && registerForm.get('country')?.invalid">Please
                        enter
                        a country</mat-error>
                </mat-form-field>
            </div>
            <div class="col-6 col-sm-12" *ngIf="registerForm.get('userType')?.value === 'doctor'">
                <mat-form-field appearance="outline">
                    <mat-label>HPCSA Number</mat-label>
                    <input matInput type="text" formControlName="mpNumber" required>
                    <mat-error *ngIf="registerForm.get('mpNumber')?.invalid">Please enter your HPCSA number</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row" *ngIf="registerForm.get('userType')?.value">

            <div class="col-6 col-sm-12" *ngIf="registerForm.get('userType')?.value === 'doctor'">
                <mat-form-field appearance="outline">
                    <mat-label>Speciality</mat-label>
                    <mat-select formControlName="speciality">
                        <mat-option *ngFor="let speciality of specialities" [value]="speciality.value">
                            {{ speciality.text }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="registerForm.get('speciality')?.touched && registerForm.get('speciality')?.invalid">Please
                        enter a speciality</mat-error>
                </mat-form-field>
            </div>
            <div [ngClass]="registerForm.get('userType')?.value === 'doctor' ? 'col-6  col-sm-12' : 'col-12'">
                <mat-form-field appearance="outline">
                    <mat-label>Email</mat-label>
                    <input matInput type="email" formControlName="email" required
                        name="email" autocomplete="username" autocapitalize="off"
                        spellcheck="false" inputmode="email">
                    <mat-error *ngIf="registerForm.get('email')?.invalid">Please enter a valid email</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row" *ngIf="registerForm.get('userType')?.value">
            <div class="col-6 col-sm-12">
                <mat-form-field appearance="outline">
                    <mat-label>Password</mat-label>
                    <input matInput [type]="showPassword ? 'text' : 'password'" formControlName="password" (input)="onPasswordInput($event)"
                        name="new-password" autocomplete="new-password">
                    <button mat-icon-button matSuffix (click)="showPassword = !showPassword" type="button" attr.aria-label="{{ showPassword ? 'Hide password' : 'Show password' }}">
                        <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <mat-progress-bar *ngIf="registerForm.get('password')?.value" mode="determinate"
                        [value]="passwordStrength"
                        [class.weak]="registerForm.get('password')?.errors?.['passwordStrength']">
                    </mat-progress-bar>
                    <mat-error
                        *ngIf="registerForm.get('password')?.touched && registerForm.get('password')?.errors?.['passwordStrength']">
                        {{ registerForm.get('password')?.errors?.['passwordStrength'] }}
                    </mat-error>
                </mat-form-field>
                <app-password-strength [password]="passValue"></app-password-strength>
            </div>
            <div class="col-6 col-sm-12">
                <mat-form-field appearance="outline">
                    <mat-label>Confirm Password</mat-label>
                    <input matInput [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword"
                        name="confirm-new-password" autocomplete="new-password">
                    <button mat-icon-button matSuffix (click)="showConfirmPassword = !showConfirmPassword" type="button" attr.aria-label="{{ showConfirmPassword ? 'Hide password' : 'Show password' }}">
                        <mat-icon>{{ showConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <mat-error *ngIf="registerForm.get('confirmPassword')?.invalid">Please confirm your
                        password</mat-error>
                    <mat-error *ngIf="registerForm.get('confirmPassword')?.hasError('passwordMismatch')">
                        Passwords do not match
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <ng-container *ngIf="registerForm.get('userType')?.value">
            <p class="hint terms-message">
                Your personal information is kept confidential and used solely for account confirmation. We do not share
                your information with any third party without your prior consent. By creating an account, you agree to
                submit the above information to MedicAI and accept our <a
                    href="assets/documents/IQject Terms of service - v0.5.pdf" target="_blank">terms & conditions</a>
                and <a href="assets/documents/IQject privacy notice - 21 January 2025.pdf" target="_blank">privacy
                    policy</a>.
            </p>
        </ng-container>
        <ng-container *ngIf="!registerForm.get('userType')?.value">
            <p>Select a User Type to get started. </p>
            <p> - <strong>Physician</strong> accounts will have the ability to create their own patient lists.</p>
            <p> - <strong>Admin Staff</strong> will need to join a Physician's list.</p>
        </ng-container>

        <app-turnstile #challenge *ngIf="registerForm.get('userType')?.value"
            (tokenChange)="turnstileToken = $event"></app-turnstile>

        <!-- Disabled while a registration is in flight. The visible label change matters as
             much as the disabled state: the only other progress indicator is a 4px bar at the
             very top of the viewport, which users miss, so they clicked Register again
             believing nothing had happened. Same pattern as the Login button. -->
        <button mat-raised-button color="primary" type="submit"
            *ngIf="registerForm.get('userType')?.value "
            [disabled]="registerForm.invalid || !challengeReady || isRegistering">
            {{ isRegistering ? 'Registering…' : 'Register' }}
        </button>
    </form>
    <div class="login-link">
        Already have an account? <a (click)="onLoginClick()">Login</a>
    </div>
</div>